import { Image, Stack, StackDivider, Text } from '@chakra-ui/react';
import { Banner } from '@time-line/components/blocks';
import { useIsDarkTheme } from 'hooks/useIsDarkMode';
import type { Certifications as CertificationsProps } from 'types/cms/blocks';

const COLORS = {
  white: {
    text: 'gray.50',
    line: 'whiteAlpha.400',
  },
  gray: {
    text: 'gray.600',
    line: 'gray.600',
  },
};

export function CertificationsBanner({
  logos,
  description,
  media,
  ...props
}: CertificationsProps) {
  const overlayColor = media?.overlayColor
    ? media.overlayColor.hex
    : 'transparent';

  const isDarkMode = useIsDarkTheme({ color: overlayColor });
  const colorScheme = isDarkMode ? 'white' : 'gray';
  const color = COLORS[colorScheme];

  return (
    <Banner subtitle={description} media={media} {...props}>
      <Stack
        mt="lg"
        direction="row"
        divider={<StackDivider borderColor={color.line} />}
        spacing="sm"
      >
        {logos?.map((item, i) => (
          <Stack key={i} width="100%" spacing="2xs" textAlign="center">
            <Image
              src={item.logo.asset.url}
              alt={item.logo.alt}
              mx="auto"
              width="xl"
              height="auto"
            />
            <Text size="detail" color={color.text}>
              {item.label}
            </Text>
          </Stack>
        ))}
      </Stack>
    </Banner>
  );
}
